module.exports = "<p>adminlogistic works!</p>\n"